import { render } from "./ProfileDropdown.vue?vue&type=template&id=8c429994&scoped=true"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"

import "./ProfileDropdown.vue?vue&type=style&index=0&id=8c429994&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c429994"]])

export default __exports__